<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="3000" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" />
							<div v-if="index == 0" class="msg_box">
								<img src="../../assets/img_public/logo_b.webp" />
								<div class="tit">Coretests provides full-cycle support from life’s conception<br /> to its completion. <br /><span>@2.1 Billion People</span></div>
								<div class="tips" @click="goMore">
									More&nbsp;<van-icon name="arrow" size="16px" color="#000000" style="position: relative;top: 3px;" />
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="indicators_box">
					<div v-for="(value, index) in bannerList" :key="index" class="indicators_el" :class="bannerIndex == index ? 'actived' : ''"></div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="tit"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Product Certifications</div>
				<div v-if="sceneList.length > 0" class="block1_banner"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-swipe
						class=""
						:loop="false"
						:autoplay="0"
						indicator-color="white"
						:stop-propagation="false"
						:show-indicators="false"
						:width="240"
					>
						<van-swipe-item v-for="(value, index) in sceneList" :key="index">
							<div class="block_main" @click="goProduct(value)">
								<img class="img_el" lazy-load :src="webUrl + value.thumb" />
								<div class="msg_box">
									<div class="title">{{ value.title }}</div>
									<div v-if="value.title == 'CE'" class="txt">Conformite Europeenne</div>
									<div v-if="value.title == 'FDA'" class="txt">U.S.Food & Drug Administration</div>
									<div v-if="value.title == 'NMPA'" class="txt">National Medical Products Administration</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="bg"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					@click="goMore"
				>
					<img src="../../assets/img_public/index/h5_block02.webp" />
				</div>
				<div class="block_2_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">
						Core Technology Co., Ltd. is a subsidiary of the American CorDx Union group. CorDx Union (hereinafter referred to as CU) was established in 2006, serving as an international group company integrating R&D, production, marketing, and service. It has 21 subsidiaries, including Accu News, Coretests technology, Abiores, Jtests, Bonore plastics, CuPet and other brands. 
					</div>
					<img src="../../assets/img_public/index/h5_block03.webp" />
				</div>
				<div class="diver"></div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="top_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Globalization</div>
					<div class="nav_box">
						<div class="nav_el" :class="addressActived == 1 ? 'actived' : ''" @click="addressClick(1)">Overseas Companies</div>
						<div class="nav_el" :class="addressActived == 2 ? 'actived' : ''" @click="addressClick(2)">Domestic Companies</div>
					</div>
					<div class="check_box">
						<template v-if="addressActived == 1">
							<div class="check_el" v-for="(value, index) in addressOut" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
						</template>
						<template v-if="addressActived == 2">
							<div class="check_el" v-for="(value, index) in addressIn" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
						</template>
					</div>
					<div class="txt">
						With the goal of becoming a first-class pharmaceutical enterprise, our companies is committed to the development of globalization. Now it has established R & D centers, production bases and sales platforms in the United States, Britain, Dubai and Singapore to serve the cause of human health wholeheartedly!
					</div>
				</div>
				<div id="mapBox" class="map_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				></div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="tit_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">Company News</div>
						<div class="right">
							<div class="h5_public_btn" @click="goNews">More<van-icon name="arrow" size="14px" class="btn_icon" /></div>
						</div>
					</div>
					<div v-if="newsOneList" class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goNewsInfo(newsOneList)"
					>
						<img :src="webUrl + newsOneList.image" />
						<div class="tit">{{ newsOneList.title }}</div>
						<div class="time">{{ newsOneList.fabu_time }}</div>
					</div>
					<div class="list_box"
						v-if="newsOtherList.length > 0"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value, index) in newsOtherList" :key="index" class="list_el" @click="goNewsInfo(value)">
							<div class="tit">{{ value.title }}</div>
							<div class="txt">{{ value.description }}</div>
							<div class="time">{{ value.fabu_time }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="bg" src="../../assets/img_public/index/zw2.webp" />
					<div class="tit">Corporate Culture</div>
					<div class="txt">Perfect quality, sincere service, standardized management, development and innovation</div>
					<div class="btn_box">
						<div class="h5_public_btn" @click="goCulture">More<van-icon name="arrow" size="14px" class="btn_icon" /></div>
					</div>
				</div>
				<div class="block_5_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="bg" src="../../assets/img_public/index/zw3.webp" />
					<div class="tit">Cordxer</div>
					<div class="txt">Grow together and create a better future for CU.</div>
					<div class="btn_box">
						<div class="h5_public_btn" @click="goMore">More<van-icon name="arrow" size="14px" class="btn_icon" /></div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import AMapLoader from '@amap/amap-jsapi-loader';
import { UPURL } from '@/util/util';
import { newsList } from '@/api/public';  //新闻列表
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [  //轮播
				{ imgUrl: require('@/assets/img_public/index/h5_banner01.webp') },
				{ imgUrl: require('@/assets/img_public/index/h5_banner02.webp') }
			],
			bannerIndex: 0,  //当前轮播索引
			addressActived: 1,
			addressActived2: 'SD,California,USA',
			addressIn: [
				{ title: 'BeiJing', lat: 40.287037, lng: 116.227463 },
				{ title: 'TianJin', lat: 39.588283, lng: 117.063738 },
				{ title: 'HeBei', lat: 39.24455, lng: 115.515995 },
				{ title: 'HeNan', lat: 35.217431, lng: 113.676265 },
				{ title: 'HuBei', lat: 30.527296, lng: 113.924629 },
				{ title: 'HaiNan', lat: 20.254845, lng: 109.76684 }
			],
			addressOut: [
				{ title: 'SD,California,USA', lat: 33.21698, lng: -117.160338 },
				{ title: 'Atlanta,Georgia,USA', lat: 33.693296, lng: -84.344735 },
				{ title: 'Singapore', lat: 1.341561, lng: 103.888903 },
				{ title: 'Dubai', lat: 25.237182, lng: 55.356834 }
			],
			mapList: null,
			loaction: null,
			sceneList: [],  //产品认证
			lang: 'en',
			lang2: sessionStorage.getItem('lang'),
			webUrl: UPURL,
			newsOneList: null,
			newsOtherList: [],
		}
	},
	created(){
		let that = this;
		//产品分类赋值
		that.sceneList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cert_list;
		//请求文章数据
		newsList({
			page: 1,
			page_size: 4,
			leixing: 1,
			language: sessionStorage.getItem('lang')
		}).then(res => {
			res.data.data.forEach((value, index) => {
				if(index == 0) {
					that.newsOneList = value;
				}else {
					that.newsOtherList.push(value);
				}
			});
		});
	},
	mounted() {
		let that = this;
		//初始化地图
		that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
		that.loaction = [-117.160338, 32.71698];
		that.$nextTick(() => {
			that.initMap();
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//跳转文章详情
		goNewsInfo(value) {
			let that = this;
			that.$router.push({ name: 'NewsInfo', params: { newInfoId: value.id + '.html' } });
		},
		//跳转新闻
		goNews() {
			this.$router.push('/news/dynamics.html');
		},
		//跳转企业文化
		goCulture() {
			this.$router.push('/about/culture.html');
		},
		//跳转公司简介
		goMore() {
			this.$router.push('/about/introduction.html');
		},
		//点击跳转产品
		goProduct(value) {
			let that = this;
			that.$router.push({ path: '/product-list.html', query: { cert_ids: value.id, } });
			setTimeout(() => {
				window.location.reload();
			}, 300);
		},
		//地点点击2
		addressClick2(value) {
			let that = this;
			if(that.addressActived2 != value.title) {
				that.addressActived2 = value.title;
				//重置地图
				that.mapList = [{ lnglats: [value.lng, value.lat], }];
				that.loaction = [value.lng, value.lat];
				that.initMap();
			}
		},
		//地点点击1
		addressClick(value) {
			let that = this;
			that.addressActived = value;
			if(that.addressActived == 1) {
				that.lang = 'en';
				that.addressActived2 = 'SD,California,USA';
				//重置地图
				that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
				that.loaction = [-117.160338, 33.21698];
				that.initMap();
			}else {
				that.lang = 'en';
				that.addressActived2 = 'BeiJing';
				//重置地图
				that.mapList = [{ lnglats: [116.227463, 40.287037], }];
				that.loaction = [116.227463, 40.287037];
				that.initMap();
			}
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
		//初始化地图
		initMap() {
			let that = this;
			AMapLoader.load({
				key:"1a79407995c8bc2abb2230330562814e",  // 申请好的Web端开发者Key，首次调用 load 时必填  c7422fb1c71586f2ab0e00eeeda9ea3e
				version:"1.4.15",  // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins:[''],  // 需要使用的的插件列表，如比例尺'AMap.Scale'等
			}).then((AMap)=>{
				that.map = new AMap.Map("mapBox",{  //设置地图容器id
					viewMode:"3D",    //是否为3D地图模式
					zoom: 0,           //初始化地图级别
					//mapStyle: 'amap://styles/whitesmoke',
					center: that.loaction, //初始化地图中心点位置640419
					lang: ''
				});
				that.setMapMarker();
				that.map.setZoom(6);
				that.map.setLang(that.lang);
			}).catch(e=>{
				console.log(e);
			});
		},
		setMapMarker () {
			let that = this;
			// 创建 AMap.Icon 实例
			let icon = new AMap.Icon({
				size: new AMap.Size(36, 36), // 图标尺寸
				image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // Icon的图像
				imageSize: new AMap.Size(24, 30), // 根据所设置的大小拉伸或压缩图片
				imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
			});
			let makerList = []
			that.mapList.forEach((item) => {
				// 遍历生成多个标记点
				let marker = new AMap.Marker({
					map: that.map,
					zIndex: 9999999,
					icon: icon, // 添加 Icon 实例
					offset: new AMap.Pixel(0, 0), //icon中心点的偏移量
					position: item.lnglats // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
				});
				makerList.push(marker)
			});
			that.map.add(makerList)
		    that.map.setFitView();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块5
	.block_5{
		padding: 35px 20px 0 20px;
		.block_5_el{
			margin-bottom: 50px;
			.txt{
				padding-bottom: 12px;
			}
			.tit{
				padding: 24px 0 4px 0;
				font-size: 20px;
				font-weight: bold;
			}
			.bg{
				width: 100%;
			}
		}
	}
	//块4
	.block_4{
		background: url(../../assets/img_public/index/h5_block04.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_4_main{
			padding: 40px 20px 20px 20px;
			.list_box{
				margin-top: 30px;
				.list_el{
					margin: 0px 0 20px 0;
					.time{
						padding-bottom: 12px;
						font-size: 14px;
						color: #999999;
					}
					.txt{
						margin-bottom: 6px;
						font-size: 16px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
					.tit{
						padding-bottom: 8px;
						font-size: 18px;
					}
					border-bottom: 1px solid #E3E1E6;
				}
			}
			.msg_box{
				overflow: hidden;
				margin: 20px 0 0px 0;
				background-color: #ffffff;
				border-radius: 8px;
				.time{
					padding: 0 10px 14px 10px;
					font-size: 14px;
					color: #999999;
				}
				.tit{
					padding: 16px 10px 6px 10px;
					font-size: 18px;
				}
				img{
					width: 100%;
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					width: auto;
				}
				.left{
					flex: 1;
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
	//块3
	.block_3{
		.map_box{
			width: 100%;
			height: 300px;
		}
		.top_box{
			padding: 40px 20px 20px 20px;
			text-align: center;
			.txt{
				padding-top: 20px;
				font-size: 16px;
			}
			.check_box{
				margin-top: 30px;
				padding: 16px 0;
				box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.05);
				border-radius: 8px;
				.check_el.actived{
					color: #A50073;
				}
				.check_el{
					display: inline-block;
					padding: 0 9px;
					border-right: 1px solid #E3E1E6;
				}
				.check_el:last-child{
					border-right: none;
				}
			}
			.nav_box{
				padding-top: 20px;
				.nav_el.actived{
					color: #A50073;
					border: 1px solid #A50073;
					border-radius: 8px;
				}
				.nav_el{
					display: inline-block;
					margin: 0 10px;
					padding: 6px 8px;
					text-align: center;
					font-size: 16px;
				}
			}
			.tit{
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
	//块2
	.block_2{
		.diver{
			height: 10px;
			background-color: #F7F6F9;
		}
		.block_2_main{
			padding: 30px 20px 50px 20px;
			img{
				width: 100%;
			}
			.tit{
				margin-bottom: 40px;
				font-size: 16px;
				// text-indent: 28px;
			}
		}
		.bg{
			img{
				width: 100%;
			}
		}
	}
	//块1
	.block_1{
		.block1_banner{
			position: relative;
			padding-bottom: 60px;
			.block_main{
				position: relative;
				margin-right: 16px;
				.msg_box{
					width: 100%;
					position: absolute;
					top: 45%;
					left: 50%;
					transform: translate(-50%, -50%);
					text-align: center;
					color: #A20073;
					.txt{
						padding-top: 5px;
						font-size: 16px;
					}
					.title{
						font-size: 30px;
					}
				}
				.tit{
					padding-top: 20px;
					text-align: center;
				}
				.img_el{
					width: 100%;
					height: 100%;
					border-radius: 8px;
				}
			}
		}
		.tit{
			padding: 40px 0 24px 0;
			font-size: 24px;
			text-align: center;
		}
	}
	//轮播图
	.banner_box{
		width: 100%;
		position: relative;
		.indicators_box{
			position: absolute;
			bottom: 10px;
			left: 50%;
			transform: translate(-50%, 0);
			.indicators_el{
				width: 40px;
				height: 2px;
				display: inline-block;
				margin: 0 5px;
				background-color: rgba(0, 0, 0, 0.3);
			}
			.actived{
				background-color: #A20073;
			}
		}
		.swipe_box{
			.swiper_el{
				.msg_box{
					width: 100%;
					margin: 0 auto;
					padding: 0 20px;
					position: absolute;
					top: 40%;
					left: 50%;
					transform: translate(-50%, -40%);
					.tips{
						font-size: 14px;
						margin-top: 20px;
						display: inline-block;
						padding: 2px 8px;
						border-radius: 8px;
						border: 1px solid #999999;
					}
					.tit{
						margin-top: 10px;
						font-size: 14px;
						color: #666666;
						span{
							font-size: 14px;
							color: #A20073;
						}
					}
					img{
						width: 160px;
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>